import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 30,
	height: 99,
	viewBox: "0 0 30 99",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.65094 1.00342L28.5483 49.7789L0.65094 98.5544",
		stroke: "currentColor",
		strokeOpacity: .2
	})
});
export default SvgArrowRight;
